import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, ArrowDownIcon } from 'lucide-react';
export function BonusScrollStopper() {
  return <section className="py-12 md:py-16 px-5 md:px-8 relative overflow-hidden" data-id="element-71">
      <div className="max-w-5xl mx-auto" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative bg-gradient-to-br from-[#0B1224] via-[#0F1830] to-[#0B1224] border-2 border-[#F6C65B]/50 rounded-3xl p-6 md:p-10 shadow-[0_0_50px_rgba(246,198,91,0.2)] overflow-hidden" data-id="element-73">
          {/* Glow */}
          <div className="absolute -top-20 -right-20 w-60 h-60 bg-[#F6C65B] rounded-full blur-[120px] opacity-20 pointer-events-none" data-id="element-74"></div>
          <div className="absolute -bottom-20 -left-20 w-60 h-60 bg-[#F6C65B] rounded-full blur-[120px] opacity-10 pointer-events-none" data-id="element-75"></div>

          <div className="relative grid md:grid-cols-2 gap-8 items-center" data-id="element-76">
            {/* Image */}
            <div className="order-2 md:order-1" data-id="element-77">
              <img src="https://cdn.magicpatterns.com/uploads/cHn5KVnczAWsGvJoR78JXy/Gemini_Generated_Image_u6vjigu6vjigu6vj.jpg" alt="4 regalos exclusivos del Protocolo Silencio TTPM" width="1024" height="1024" loading="lazy" decoding="async" className="w-full max-w-md mx-auto rounded-2xl shadow-2xl" data-id="element-78" />
            </div>

            {/* Copy */}
            <div className="order-1 md:order-2 text-center md:text-left" data-id="element-79">
              <div className="inline-flex items-center gap-2 bg-[#F6C65B]/15 border border-[#F6C65B]/40 rounded-full px-4 py-1.5 mb-4" data-id="element-80">
                <GiftIcon className="w-4 h-4 text-[#F6C65B]" data-id="element-81" />
                <span className="text-[#F6C65B] text-xs md:text-sm font-bold tracking-widest uppercase" data-id="element-82">
                  Bonos exclusivos
                </span>
              </div>

              <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight mb-4" data-id="element-83">
                ¡<span className="text-[#F6C65B]" data-id="element-84">ESPERA</span>!
              </h2>

              <p className="text-lg md:text-xl text-gray-200 leading-relaxed mb-4" data-id="element-85">
                Tu orden de hoy incluye{' '}
                <span className="text-[#F6C65B] font-bold" data-id="element-86">
                  4 REGALOS EXCLUSIVOS GRATIS
                </span>{' '}
                (valorados en total en{' '}
                <span className="text-[#F6C65B] font-bold" data-id="element-87">$200 USD</span>)
                diseñados para acelerar tu silencio y descanso{' '}
                <span className="underline decoration-[#F6C65B]/60 underline-offset-4" data-id="element-88">
                  desde la primera noche
                </span>
                .
              </p>

              <p className="text-gray-400 text-sm md:text-base mb-6" data-id="element-89">
                Sigue leyendo para descubrir cómo reclamarlos. 👇
              </p>

              <div className="flex justify-center md:justify-start" data-id="element-90">
                <motion.div animate={{
                y: [0, 8, 0]
              }} transition={{
                duration: 1.8,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="inline-flex items-center gap-2 text-[#F6C65B] font-semibold" data-id="element-91">
                  <ArrowDownIcon className="w-5 h-5" data-id="element-92" />
                  <span className="text-sm" data-id="element-93">No te pierdas ningún bono</span>
                </motion.div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}